const SUPPORTED_TEXT_DECORATION = 'line-through';

const hasStrikethroughStyle = (element) => {
  const { textDecoration } = element.style;
  return textDecoration.includes(SUPPORTED_TEXT_DECORATION);
};
export default hasStrikethroughStyle;
